module.exports = __webpack_public_path__ + "img/mealreminder-user-1.ca1488b6.png";